import { DatastoreProvider, InstanceScreen } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { Stack, useLocalSearchParams } from 'expo-router';

const moduleFn = () => import('feature/ranking-eval/ranking-eval-module');

export default function RankingEvalCommentScoringScreen() {
    const { instanceKey, siloKey } = useLocalSearchParams<'/[siloKey]/ranking-eval/one/comment-scoring/[instanceKey]'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'ranking-eval',
        instanceKey,
        moduleFn,
    });

    return (
        <>
            <Stack.Screen options={{ title: instanceKey }} />
            <DatastoreProvider {...instanceConfig}>
                <InstanceScreen screenKey='comment-scoring/[instanceKey]' />
            </DatastoreProvider>
        </>
    );
}
